import React, { useEffect, useRef, useState } from "react";
import { HeaderDesktop, HeaderMobile } from "./layout/appHeader/index";
import NavBar from "./layout/appNav/VerticalNavWrapper";
import { Login } from "./pages/index";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./app.css";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import classNames from "classnames";
import { withSnackbar } from "./utils/SnackbarHOC";
import useOnlineStatus from "./utils/useOnlineStatus ";
import {
  Box,
  MuiThemeProvider,
  createTheme,
  useMediaQuery,
} from "@material-ui/core";
import { theme } from "./utils/Theme";
import ResponsiveLayout from "./layout/LayoutReponsive/LayoutResponsive";
import PrivatesRoutes from "./routes";
import { Provider } from "react-redux";
import store from "./redux/store/store";
import SwipeableDrawerSummary from "./components/SwipeableDrawerSummary";
import MailingModal from "./components/MailingModal/MailingModal";
import ChatBot from "./components/ChatBot/ChatBot";
import { getUserData } from "./utils/FunctionHelpers";
import NotificationSound from "./assets/sounds/notification-sound.mp3";
import { getUserNotifications } from "./pages/Services/NotificationService";

function App({ snackbarShowMessage }) {
  const [sideBarCollapsed, setSideBarCollapsed] = useState(false);
  const isOnline = useOnlineStatus();
  const [notifications, setNotifications] = useState([]);

  const isMdMode = useMediaQuery(theme.breakpoints.down(993));
  const isSmMode = useMediaQuery(theme.breakpoints.between(0, 480));

  const playNotificationSound = () => {
    const audio = new Audio(NotificationSound);
    audio.play();
  };

  const loadNotifications = async () => {
    const { data } = await getUserNotifications();
    setNotifications(data);
    if (data.filter((notification) => !notification.seen).length > 0) {
      snackbarShowMessage(
        "Vous avez des nouvelles notifications !",
        "info",
        2000,
        "bottom",
        "left"
      );
    }
  };

  useEffect(() => {
    if (getUserData()) {
      loadNotifications();
      const notificationHubUrl = `${process.env.NODE_ENV === 'production' ? window.location.origin : "http://localhost:4000"}/.well-known/mercure`
      const url = new URL(notificationHubUrl);
      url.searchParams.append("topic", `user/${getUserData()?.uuid}`);

      const eventSource = new EventSource(url);

      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        setNotifications((prev) => [data.data, ...prev]);
        snackbarShowMessage(
          "Une nouvelle tâche vous a été assignée",
          "info",
          2000,
          "bottom",
          "left"
        );
        playNotificationSound();
      };

      return () => {
        eventSource.close();
      };
    }
  }, [getUserData()?.uuid]);

  const handleClick = () => {
    setSideBarCollapsed(!sideBarCollapsed);
  };

  const navBarProps = {
    sideBarCollapsed: sideBarCollapsed,
  };
  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            backgroundColor: "#FFF",
            padding: "8px",
          },
        },
      },
    });
  return (
    <Provider store={store}>
      <MuiThemeProvider theme={getMuiTheme()}>
        <BrowserRouter>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Switch>
              <Route path="/login">
                <Login snackbarShowMessage={snackbarShowMessage} />
              </Route>
              <>
                <div
                  className={classNames({
                    main_content: true,
                    dashboard_part: true,
                  })}
                >
                  <Box className="box">
                    <Box className="box_container">
                      {!isMdMode && (
                        <Box className="box_sideBar">
                          <NavBar {...navBarProps} onClick={handleClick} />
                        </Box>
                      )}
                      <Box className="box_main">
                        <Box
                          className="box_header "
                          sx={isSmMode ? { marginBottom: "4rem" } : {}}
                        >
                          {isMdMode ? (
                            <HeaderMobile handleClick={handleClick} />
                          ) : (
                            <HeaderDesktop
                              notifications={notifications}
                              setNotifications={setNotifications}
                              handleClick={handleClick}
                            />
                          )}
                        </Box>
                        <ResponsiveLayout>
                          <PrivatesRoutes />
                        </ResponsiveLayout>
                      </Box>
                    </Box>
                  </Box>
                  <MailingModal />
                  <SwipeableDrawerSummary />
                  {getUserData() && <ChatBot />}
                </div>
              </>
            </Switch>
          </MuiPickersUtilsProvider>
          {!isOnline &&
            snackbarShowMessage("Vous êtes déconnecté...", "error", 4000)}
        </BrowserRouter>
      </MuiThemeProvider>
    </Provider>
  );
}

export default withSnackbar(App);
